var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.541,
    height: 28.887,
    viewBox: "0 0 32.541 28.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Home_white",
    className: "cls-1",
    d: "M31.851,11.4,26.708,7.389V2.418a.469.469,0,0,0-.458-.48H23.793a.469.469,0,0,0-.48.458V4.75L17.93.567a2.678,2.678,0,0,0-3.292,0L.717,11.4A1.868,1.868,0,0,0,0,12.875v.72a1.141,1.141,0,0,0,1.132,1.132H3.875V27.071a1.829,1.829,0,0,0,1.817,1.817h7.166V19.63A1.141,1.141,0,0,1,13.99,18.5h4.56a1.141,1.141,0,0,1,1.132,1.132v9.258h7.166a1.829,1.829,0,0,0,1.817-1.817V14.727h2.743A1.141,1.141,0,0,0,32.54,13.6v-.72a1.787,1.787,0,0,0-.686-1.474Z",
    transform: "translate(0 -0.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhite);
export default __webpack_public_path__ + "static/media/Home_white.67d22d8b2b64a28a68d27b986e109f24.svg";
export { ForwardRef as ReactComponent };